export default __webpack_public_path__ + "static/media/convocatoria2026.725580ce.pdf";